import React, { useState } from 'react';
import Modal from 'react-modal';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import classNames from 'classnames';
import { FaCog } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import DetailedBlogInfo from '@/components/reusable/DetailedBlogInfo/DetailedBlogInfo';
import './NewBlogCardShortVersion.scss';

Modal.setAppElement('#root');

const truncateDescription = (description, limit) => {
  if (description?.length > limit) {
    return description.substring(0, limit) + '...';
  }
  return description;
};

const NewBlogCardShortVersion = props => {
  const {
    blogInfo,
    isMobileStyle,
    handleDetailButton,
    isInlineStyle,
    onUpdate,
  } = props;

  const user = useSelector(state => state.user);
  const languageData = useSelector(state => state.lenguage?.lang);
  console.log('ver user;', user);

  const formatDateShort = dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // enero = 0
    const year = String(date.getFullYear()).slice(2); // solo los dos últimos dígitos
    return `${day}.${month}.${year}`;
  };

  let imageItemStyle = {};
  if (isInlineStyle) {
    imageItemStyle = { width: '100%' };
  } else {
    imageItemStyle = isMobileStyle
      ? {
          height: '100px',
          width: '100%',
          borderTopLeftRadius: '18px',
          borderTopRightRadius: '18px',
        }
      : {
          width: '100%',
          height: '220px',
        };
  }

  const imageToDisplay = (() => {
    try {
      const parsed =
        typeof blogInfo?.post_img === 'string'
          ? JSON.parse(blogInfo?.post_img)
          : blogInfo?.post_img;

      return Array.isArray(parsed) && parsed.length > 0
        ? parsed[0] instanceof File
          ? URL.createObjectURL(parsed[0])
          : parsed[0]
        : blogInfo?.post_img;
    } catch {
      return blogInfo?.post_img;
    }
  })();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  let subtitle;

  const customModalStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1000,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
    },
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <FlexContainer
      className={'flex-column width100'}
      onClick={handleDetailButton}
      style={{ position: 'relative' }}
    >
      {/*  {user && (
        <div
          className="icon-container"
          onClick={e => {
            e.stopPropagation();
            console.log('Icon clicked', blogInfo);
            openModal();
          }}
        >
          <FaCog size={24} color="#808080" />
        </div>
      )} */}

      <FlexContainer className="width100 bgBlue400 height-220px">
        <img
          src={imageToDisplay}
          alt={blogInfo?.post_keywords}
          style={{
            ...imageItemStyle,
            objectFit: 'cover',
          }}
        />
      </FlexContainer>
      <FlexContainer className={'flex-column width100'}>
        <Label type="text-12 margtb14">
          {formatDateShort(blogInfo?.post_date)}
        </Label>
        <Label className="text-18 margb10 margt10 bold">
          <strong>
            {truncateDescription(
              languageData === 'EN'
                ? blogInfo?.post_title_en
                : blogInfo?.post_title,
              150,
            )}
          </strong>
        </Label>
      </FlexContainer>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Detailed Blog Info"
      >
        <div onClick={e => e.stopPropagation()}>
          <DetailedBlogInfo
            blogInfo={blogInfo}
            closeModal={closeModal}
            onSave={updatedBlog => {
              if (onUpdate) {
                onUpdate({ ...updatedBlog, type_title: blogInfo.type_title });
              }
              closeModal();
            }}
          />
        </div>
      </Modal>
    </FlexContainer>
  );
};

export default NewBlogCardShortVersion;
